export default "__VITE_ASSET__J_zjnKp7__"